function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M496.7,71.4c8.9,0,16,7.2,16,16v16c0,8.9-7.2,16-16,16H175.8c-8.9,0-16-7.2-16-16v-16c0-8.9,7.2-16,16-16H496.7 z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M79.5,47.3c8.9,0,16,7.2,16,16v64.1c0,8.9-7.2,16-16,16H15.3c-8.9,0-16-7.2-16-16V63.4c0-8.9,7.2-16,16-16H79.5 z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M495.8,71.3c8.8,0,16,7.2,16,16v16c0,8.8-7.2,16-16,16H176.1c-8.8,0-16-7.2-16-16v-16c0-8.8,7.2-16,16-16H495.8 z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M80.1,47.3c8.8,0,16,7.2,16,16v63.9c0,8.8-7.2,16-16,16H16.2c-8.8,0-16-7.2-16-16V63.3c0-8.8,7.2-16,16-16H80.1 z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M80,48H16C7.2,48,0,55.2,0,64v64c0,8.8,7.2,16,16,16h64c8.8,0,16-7.2,16-16V64C96,55.2,88.8,48,80,48z"
}), React.createElement("path", {
  d: "M496,72H176c-8.8,0-16,7.2-16,16v16c0,8.8,7.2,16,16,16h320c8.8,0,16-7.2,16-16V88C512,79.2,504.8,72,496,72z"
}), React.createElement("path", {
  d: "M497.5,168.8h-14.2c-7.9,0-14.2,6.4-14.2,14.2v11.5l-270.9,71.7c-1.5-6.3-6.9-11-13.6-11h-14.2c-7.9,0-14.2,6.4-14.2,14.2 v120.3c0,7.9,6.4,14.2,14.2,14.2h14.2c6.7,0,12.1-4.8,13.6-11l48.3,11.3c-1,5.1-2,10.3-2,15.8c0,47.1,38.2,74.7,85.3,74.7 c39.2,0,71.9-16.1,81.8-52.2l57.6,12.2v11.5c0,7.9,6.4,14.2,14.2,14.2h14.2c7.9,0,14.2-6.4,14.2-14.2V183.1 C511.8,175.2,505.4,168.8,497.5,168.8z M329.8,452.1c-23.5,0-42.6-8.6-42.6-32.1c0-2.1,0.8-4,1.1-6.1l81.9,19 C364.7,450,348.7,452.1,329.8,452.1z M469.1,407.4l-270.2-58v-39.5l270.2-71.6V407.4z"
}));

var SvgListMegaphone = function SvgListMegaphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgListMegaphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-megaphone.decd4da1.svg";
export { ForwardRef as ReactComponent };